import { Instance } from 'mobx-state-tree';
import { ProjectOptimizeFailedDtoModelBase } from './ProjectOptimizeFailedDtoModel.base';

/* The TypeScript type of an instance of ProjectOptimizeFailedDtoModel */
export interface ProjectOptimizeFailedDtoModelType extends Instance<typeof ProjectOptimizeFailedDtoModel.Type> {}

/* A graphql query fragment builders for ProjectOptimizeFailedDtoModel */
export { selectFromProjectOptimizeFailedDto, projectOptimizeFailedDtoModelPrimitives, ProjectOptimizeFailedDtoModelSelector } from './ProjectOptimizeFailedDtoModel.base';

/**
 * ProjectOptimizeFailedDtoModel
 *
 * Optimize failed
 */
export const ProjectOptimizeFailedDtoModel = ProjectOptimizeFailedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
